import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Menu from './src/menu'
import MenuItem from './src/menu-item.vue'
import MenuItemGroup from './src/menu-item-group.vue'
import SubMenu from './src/sub-menu'

export const SgMenu = withInstall(Menu, {
  MenuItem,
  MenuItemGroup,
  SubMenu,
})
export default SgMenu
export const SgMenuItem = withNoopInstall(MenuItem)
export const SgMenuItemGroup = withNoopInstall(MenuItemGroup)
export const SgSubMenu = withNoopInstall(SubMenu)

export * from './src/menu'
export * from './src/menu-item'
export * from './src/menu-item-group'
export * from './src/sub-menu'
export * from './src/types'
